var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.printers)?_c('b-form-select',{attrs:{"size":"sm","options":_setup.printers},model:{value:(_setup.printer),callback:function ($$v) {_setup.printer=$$v},expression:"printer"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }